<template>
    <transition name="fade">
      <div v-if="visible" class="alert-overlay">
        <div class="alert-box">
          <div class="alert-icon"></div>
          <h3 class="alert-title">{{ title }}</h3>
          <p class="alert-message">{{ message }}</p>
  
          <button class="alert-btn" @click="closeAlert">
            OK
          </button>
        </div>
      </div>
    </transition>
  </template>
  
  <script>
  export default {
    props: {
      visible: Boolean,
      title: {
        type: String,
        default: "Alert"
      },
      message: {
        type: String,
        required: true
      }
    },
    methods: {
      closeAlert() {
        this.$emit("close");
      }
    }
  };
  </script>
  
  <style scoped>
  .alert-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(4px); /* 🔥 modern blur effect */

  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.alert-box {
  background: #fff;
  padding: 25px 30px;
  border-radius: 12px;
  width: 440px;
  text-align: center;

  box-shadow: 0 10px 30px rgba(0,0,0,0.2);
  animation: scaleIn 0.25s ease;
}

.alert-title {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 10px;
  color: #333;
}

.alert-message {
  font-size: 14px;
  color: #666;
  margin-bottom: 20px;
}

.alert-btn {
  padding: 10px 20px;
  border: none;
  border-radius: 6px;
  background: #cc0a24;
  color: white;
  font-weight: 500;
  cursor: pointer;
  transition: 0.2s;
}

.alert-btn:hover {
  background: #d10303;
}

.alert-icon {
  font-size: 30px;
  margin-bottom: 10px;
}

/* Animation */
@keyframes scaleIn {
  from {
    transform: scale(0.8);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}
  </style>